import useWindowSize from '@hooks/useWindowSize';
import Container from '@layout/Components/Container';
import React from 'react';
import Dynamic from '@base/Dynamic/Dynamic';
import { useToggleable } from '@stores/toggleables';
import { LOGIN_DRAWER } from '@constants/toggleables';
import Drawer from '@base/Drawer/Drawer';
import Login from '@cont/Login/Login';
import { useLayoutOptions } from '@hooks/useLayoutOptions';
import IconsFooter from './IconsFooter';
import IconsHeader from './IconsHeader';

const IconsAppNudge = Dynamic(
  () => import('@unicons-comp/IconsAppNudge/IconsAppNudge')
);
interface IconsLayoutProps {
  children: React.ReactNode;
  showFooter?: boolean;
}

const ContainerComp = Container as any;
const LoginComp = Login as any;

const IconsLayout: React.FC<IconsLayoutProps> = ({ showFooter, children }) => {
  const { isOpen: showLoginDrawer, closeElement: closeLoginDrawer } =
    useToggleable(LOGIN_DRAWER);
  const { isCheckoutUrl } = useLayoutOptions();
  const { isMobile } = useWindowSize();
  const renderLogin = () => {
    if (!isCheckoutUrl) {
      return (
        <Drawer login drawerState={showLoginDrawer} onClose={closeLoginDrawer}>
          <LoginComp />
        </Drawer>
      );
    }
  };

  return (
    <ContainerComp backgroundColor="var(--color-i-all-black)">
      <IconsHeader isCheckoutUrl={isCheckoutUrl} />
      {renderLogin()}

      {children}
      {showFooter && <IconsFooter />}
      {isMobile && <IconsAppNudge />}
    </ContainerComp>
  );
};

IconsLayout.defaultProps = {
  showFooter: true
};

IconsLayout.displayName = 'IconsLayout';

export default IconsLayout;
